import React from 'react';

import TradingFormSectionInline from '../components/TradingFormSectionInline';
import {IConfirmDetailsSubStepProps} from '../companyDetails.types';

const ConfirmDetailsSubStep: React.FC<IConfirmDetailsSubStepProps> = ({
  companyDetailsSection,
  detailsFormRef,
  submitDetailsChanges,
  isSubmitting,
  detailsError,
  companyType,
}) => {
  if (!companyDetailsSection) {
    return (
      <div className="company-info-panel">
        <p>
          We couldn’t find a company details form for this profile yet. Refresh
          data and try again.
        </p>
      </div>
    );
  }

  return (
    <TradingFormSectionInline
      ref={detailsFormRef}
      title="Company details"
      description="Update your personal, company and address information directly below."
      fields={(companyDetailsSection.fields || []) as any}
      onSubmit={submitDetailsChanges}
      isSubmitting={isSubmitting}
      errorMessage={detailsError}
      entityTypeTitle={companyType}
    />
  );
};

export default ConfirmDetailsSubStep;

export {ConfirmDetailsSubStep};
